import React from 'react';

import classes from './BackgroundBlur.module.css';

const BackgroundBlur = () => {
  return <div className={classes.backgroundBlur}></div>;
};

export default BackgroundBlur;
